import React from 'react'
import { Link } from 'gatsby'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        inProgress="true"
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Text Input"
          text="Use the default text field when the expected input is a single line, such as a name or phone number."
          code={code.input}
        >
          <div>
            <label for="label-1" className="c-label">
              Label Name
            </label>
            <input
              type="text"
              className="c-text-field"
              id="label-1"
              placeholder="e.g. Homer J. Simpson"
            />
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Text Area"
          text="	Use the textarea field when the expected input is more than one line, such as a comment or contact request."
          code={code.textarea}
        >
          <div>
            <label for="label-2" className="c-label">
              Label Name
            </label>
            <textarea
              name=""
              className="c-textarea"
              id="label-2"
              placeholder="Textarea placeholder"
            ></textarea>
          </div>
        </Showcase>
        <SectionTitle>States</SectionTitle>{' '}
        <p>
          In addition to the default state, both types of text inputs have
          hover, focus, change and blur states. Optional success and loading
          states are also available. The error state takes the form of an{' '}
          <Link to="/components/inline-error/develop">`Input Error`</Link>{' '}
          component.
        </p>
        <Showcase
          site={data.site}
          title="Success Text Input"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Euismod nisi porta lorem mollis. Neque volutpat ac tincidunt vitae semper. Libero id faucibus nisl tincidunt eget nullam non. Feugiat scelerisque varius morbi enim."
          code={code.success}
        >
          <div>
            <label for="label-3" className="c-label">
              Label Name
            </label>
            <input
              type="text"
              className="c-text-field"
              id="label-3"
              placeholder="e.g. Homer J. Simpson"
              value="John Doe"
            />
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Disabled Text Input"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Euismod nisi porta lorem mollis. Neque volutpat ac tincidunt vitae semper. Libero id faucibus nisl tincidunt eget nullam non. Feugiat scelerisque varius morbi enim."
          code={code.disabled}
        >
          <div>
            <label for="label-4" className="c-label">
              Label Name
            </label>
            <input
              type="text"
              className="c-text-field--disabled"
              id="label-4"
              placeholder="e.g. Homer J. Simpson"
              value="John Doe"
              disabled
            />
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Disabled Text Area"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Euismod nisi porta lorem mollis. Neque volutpat ac tincidunt vitae semper. Libero id faucibus nisl tincidunt eget nullam non. Feugiat scelerisque varius morbi enim."
          code={code.textAreaDisabled}
        >
          <div>
            <label for="label-5" className="c-label">
              Label Name
            </label>
            <textarea
              name=""
              className="c-textarea c-textarea--disabled"
              id="label-5"
              placeholder="The quick brown fox jumps over the lazy dog."
            ></textarea>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  input: `<label for="label-1" class="c-label">Label Name</label> 
<input type="text" class="c-text-field" id="label-1" placeholder="Text input placeholder"/>
`,
  textarea: `<label for="label-2" class="c-label">Label Name</label> 
<textarea name="" class="c-textarea"  id="label-2" placeholder="Textarea placeholder"></textarea>
`,
  success: `<label for="label-3" class="c-label">Label Name</label> 
<input type="text" class="c-text-field" id="label-3" placeholder="Text input placeholder" value="John Doe"/>
`,
  disabled: `<label for="label-4" class="c-label">Label Name</label> 
<input type="text" class="c-text-field--disabled" disabled id="label-4" placeholder="Text input placeholder" value="John Doe"/>
`,
  textAreaDisabled: `<label for="label-5" className="c-label">
  Label Name
</label>
<textarea
  name=""
  className="c-textarea c-textarea--disabled"
  id="label-5"
  placeholder="Textarea placeholder"
></textarea>`,
}
